import "../../../assets/scss/instance-card-style.scss";
import { useTranslation } from "react-i18next";

export const NotFound = () => {
  const { t } = useTranslation();

  return <div>{t("Page Not Found.")}</div>;
};
